export enum LogType {
  AUDIT = "audit",
}
